module.exports = __webpack_public_path__ + "img/client-logo-5.c832547c.png";